import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { UiModalComponent, } from '@components/ui-modal/ui-modal.component';
import { QueueItemService } from '@services';
import { UiSuggestComponent, } from '@uipath/angular/components/ui-suggest';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
var TransactionReviewerModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TransactionReviewerModalComponent, _super);
    function TransactionReviewerModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading$ = new BehaviorSubject(false);
        _this.reviewer = null;
        _this._queueItemService = _this._injector.get(QueueItemService);
        _this.suggestReviewers = function (searchTerm, fetchSize, skip) {
            if (fetchSize === void 0) { fetchSize = 10; }
            if (skip === void 0) { skip = 0; }
            return _this._queueItemService.suggestReviewers(searchTerm, fetchSize, skip);
        };
        return _this;
    }
    TransactionReviewerModalComponent.prototype.ngOnInit = function () {
        var reviewer = this.context.data
            .map(function (item) { return item.reviewer; })
            .reduce(function (previous, current) {
            return !!previous && !!current &&
                previous.id === current.id ?
                previous :
                undefined;
        });
        var isSameReviewer = !!reviewer;
        if (!!this.context.data.length &&
            isSameReviewer &&
            reviewer != null) {
            this.reviewer = {
                id: reviewer.id,
                text: reviewer.userName,
            };
        }
    };
    TransactionReviewerModalComponent.prototype.onSubmit = function () {
        var _this = this;
        if (this.loading$.value) {
            return;
        }
        var userId = this.suggestComponent.value[0] ?
            this.suggestComponent.value[0].id :
            null;
        this.loading$.next(true);
        this._queueItemService
            .changeItemReviewer(this.context.data, userId)
            .pipe(finalize(function () { return _this.loading$.next(false); })).subscribe(function (response) {
            _this._dialogRef.close({
                type: 0 /* Generic */,
                data: response,
            });
        });
    };
    return TransactionReviewerModalComponent;
}(UiModalComponent));
export { TransactionReviewerModalComponent };
